import visibilityHide from '@ingka/ssr-icon/paths/visibility-hide';
import incorrect from '@ingka/ssr-icon/paths/incorrect';
import calendar from '@ingka/ssr-icon/paths/calendar';
import pencil from '@ingka/ssr-icon/paths/pencil';
import trashCan from '@ingka/ssr-icon/paths/trash-can';
import folder from '@ingka/ssr-icon/paths/folder';
import ExclamationMark from '../../svg/ExclamationMark';
import Translation from '../../svg/Translation';
import RemoveDuplicate from '../../svg/RemoveDuplicate';
import Cogs from '../../svg/Cogs';
import type { BadgeProps } from './Badge';
import styles from './StatusBadges.module.scss';
import circleHalf from '@ingka/ssr-icon/paths/circle-half';

interface BadgeConfig {
  label: string;
  className: string;
  tooltip?: string;
  iconPath?: BadgeProps['iconPath'];
  CustomIcon?: BadgeProps['CustomIcon'];
  labelCompact?: string;
}

// Publish badges
export const newBadge: BadgeConfig = {
  label: 'New',
  tooltip: 'New',
  className: styles.publish,
};

export const notAvailable: BadgeConfig = {
  label: 'Not available',
  tooltip: 'Not available for markets',
  iconPath: incorrect,
  className: styles.publish,
};

export const hide: BadgeConfig = {
  label: 'Hide',
  tooltip: 'Hidden from navigation & internal search',
  iconPath: visibilityHide,
  className: styles.publish,
};

export const futurePublishDate: BadgeConfig = {
  label: 'Future publish date',
  tooltip: 'Future publish date',
  iconPath: calendar,
  className: styles.publish,
};

// Translation badges
export const autoTranslated: BadgeConfig = {
  label: 'Auto-translated',
  labelCompact: 'Auto',
  tooltip: 'Auto-translated',
  className: styles.translation,
};

export const notVerified: BadgeConfig = {
  label: 'Not verified',
  tooltip: 'Not verified',
  CustomIcon: ExclamationMark,
  className: styles.translation,
};

export const notVerifiedRenamed: BadgeConfig = {
  label: 'Not verified - Renamed by Global',
  labelCompact: 'GBL',
  tooltip: 'Not verified - Renamed by Global',
  iconPath: pencil,
  className: styles.translation,
};

export const untranslated: BadgeConfig = {
  label: 'Untranslated',
  tooltip: 'Untranslated',
  CustomIcon: Translation,
  className: styles.translation,
};

// Delete badges
export const deleted: BadgeConfig = {
  label: 'Deleted',
  tooltip: 'Deleted',
  iconPath: trashCan,
  className: styles.deleted,
};

export const removedDoubleExposure: BadgeConfig = {
  label: 'Removed double exposure',
  tooltip: 'Removed double exposure',
  CustomIcon: RemoveDuplicate,
  className: styles.deleted,
};

// Auto-categorised badge
export const autoCategorised: BadgeConfig = {
  label: 'Auto-categorisable',
  tooltip: 'Auto-categorisable',
  CustomIcon: Cogs,
  className: styles.autocategorized,
};

// Category type badges
export const categoryTypeSystem: BadgeConfig = {
  label: 'System',
  iconPath: folder,
  className: styles.categorytype,
};

export const categoryTypeAccessories: BadgeConfig = {
  label: 'Accessories',
  iconPath: folder,
  className: styles.categorytype,
};

export const categoryTypeFurniture: BadgeConfig = {
  label: 'Furniture',
  iconPath: folder,
  className: styles.categorytype,
};

export const categoryTypeUndefined: BadgeConfig = {
  label: 'Missing category type',
  iconPath: folder,
  className: styles.categorytypemissing,
};

// Summary badge (used for count displays)
export const summary: BadgeConfig = {
  label: '',
  tooltip: 'Actions required',
  className: styles.summaryInverted,
};

export const inactiveShop: BadgeConfig = {
  label: 'Inactive',
  tooltip: 'Inactive shop',
  iconPath: circleHalf,
  className: styles.summary,
};
